import { render, staticRenderFns } from "./_tabToDoList.vue?vue&type=template&id=4ced8e3a&"
import script from "./_tabToDoList.vue?vue&type=script&lang=js&"
export * from "./_tabToDoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports